var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"TransWidth"}},[_c('router-view')],1),_c('img',{staticClass:"ToTop",attrs:{"src":require("@/assets/top.png")},on:{"click":_vm.topTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }